import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { ActivationCodeModel } from '../models/activation-code.model';

import { AuthService } from '../services/auth.service';
import { RegistrationService } from '../services/registration.service';

@Injectable({providedIn: 'root'})

export class RegistrationGuard implements CanActivate {

  /**
   * The Constructor for the Registration guard.
   *
   * @param router The Router
   * @param authService
   * @param registrationService
   */
  public constructor(
    private router: Router,
    private authService: AuthService,
    private registrationService: RegistrationService,
  ) {
  }

  /**
   * Checks whether the requested route can actually be activated.
   *
   * @param route The ActivatedRouteSnapshot
   * @param state The RouterStateSnapshot
   *
   * @return boolean
   */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    if (this.registrationService.activation.activationCode.valid) {
      return true;
    }

    const activationCode = new ActivationCodeModel(route.params.code);

    return this.registrationService.sendActivationCode(activationCode).pipe(
      map(() => {
        return true;
      }),
      catchError(() => {
        return this.router.navigate(['/login']);
      }),
    );
  }
}
